import * as React from "react";
import { RgbaColorPicker } from "react-colorful";
import { useTimeTableColor } from "../../state/storeTimeTableColor";
import ShowHideHightLight from "./ShowHideHightLight";
import SaveColorBtn from "./SaveColorBtn";
import SwitchColorPanel from "./SwitchColorPanel";
import { useControlScroll } from "../../hooks/useControlScroll";

const ColorPickerBG = () => {
    const updateShowTextColor = useTimeTableColor((state) => state.updateShowTextColor);
    const updateFirstBG = useTimeTableColor((state) => state.updateFirstBG);
    const updateSecondBG = useTimeTableColor((state) => state.updateSecondBG);
    const updateEvenBG = useTimeTableColor((state) => state.updateEvenBG);
    const updateOddBG = useTimeTableColor((state) => state.updateOddBG);
    const updateBorderClr = useTimeTableColor((state) => state.updateBorderClr);
    const updateLightBG = useTimeTableColor((state) => state.updateLightBG);
    const updateBorderSize = useTimeTableColor((state) => state.updateBorderSize);
    const updateBorderStyle = useTimeTableColor((state) => state.updateBorderStyle);

    const rgba_first_bg = useTimeTableColor((state) => state.rgba_first_bg);
    const rgba_second_bg = useTimeTableColor((state) => state.rgba_second_bg);
    const rgba_odd_bg = useTimeTableColor((state) => state.rgba_odd_bg);
    const rgba_even_bg = useTimeTableColor((state) => state.rgba_even_bg);
    const rgba_light_bg = useTimeTableColor((state) => state.rgba_light_bg);
    const rgba_border_clr = useTimeTableColor((state) => state.rgba_border_clr);
    const rgba_border_size = useTimeTableColor((state) => state.rgba_border_size);
    const rgba_border_style = useTimeTableColor((state) => state.rgba_border_style);

    const { controlCustomScroll, refScroll } = useControlScroll();

    return (
        <div
            onScroll={controlCustomScroll}
            ref={refScroll}
            className="bg-white flex-col overflow-x-hidden min-w-fit h-screen py-6 px-3"
        >
            <div className="py-3 flex flex-col gap-1">
                <button
                    className="bg-green-600 px-2 py-2 rounded-md text-white"
                    onClick={() => updateShowTextColor(true)}
                >
                    Click To Switch: Now is Background Color
                </button>
                <ShowHideHightLight />
                <SaveColorBtn />
            </div>

            {/* First Head BG */}
            <div className="py-4">
                <div>First Head BG</div>
                <RgbaColorPicker
                    id="first-head-bg"
                    color={rgba_first_bg}
                    onChange={updateFirstBG}
                />
                <SwitchColorPanel />
            </div>

            {/* Second Head BG */}
            <div className="py-4">
                <div>Second Head BG</div>
                <RgbaColorPicker
                    id="second-head-bg"
                    color={rgba_second_bg}
                    onChange={updateSecondBG}
                />
                <SwitchColorPanel />
            </div>

            {/* Odd Row BG */}
            <div className="py-4">
                <div>Odd Row BG</div>
                <RgbaColorPicker
                    id="odd-row-bg"
                    color={rgba_odd_bg}
                    onChange={updateOddBG}
                />
                <SwitchColorPanel />
            </div>

            {/* Even Row BG */}
            <div className="py-4">
                <div>Even Row BG</div>
                <RgbaColorPicker
                    id="even-row-bg"
                    color={rgba_even_bg}
                    onChange={updateEvenBG}
                />
                <SwitchColorPanel />
            </div>

            {/* Highlight Row BG */}
            <div className="py-4">
                <div>Highlight Row BG</div>
                <RgbaColorPicker
                    id="highlight-row-bg"
                    color={rgba_light_bg}
                    onChange={updateLightBG}
                />
                <div className="flex items-center">
                    <SwitchColorPanel />
                    <ShowHideHightLight />
                </div>
            </div>

            {/* Border Line Color */}
            <div className="py-4">
                <div>Border Line Color</div>
                <RgbaColorPicker
                    id="border-line-color"
                    color={rgba_border_clr}
                    onChange={updateBorderClr}
                />
                <SwitchColorPanel />
            </div>

            {/* Border Line Size */}
            <div className="flex flex-col py-8">
                <div>Border Line Size</div>
                <input
                    id="border-line-size"
                    onChange={(e) => updateBorderSize(+e.target.value)}
                    type="range"
                    min="0"
                    max="10"
                    value={rgba_border_size}
                    className="slider"
                />
                <span>{rgba_border_size}px</span>
            </div>

            {/* Border Line Style */}
            <div className="py-4">
                <div>Borderline Style Type to Change</div>
                <input
                    id="border-line-style"
                    onChange={(e) => updateBorderStyle(e.target.value)}
                    type="text"
                    value={rgba_border_style}
                    className="slider"
                />
                    <div>
                        <ul className="flex items-center gap-2 mt-3">
                             <li>dashed</li>
                             <li>dotted</li>
                             <li>solid</li>                               
                        </ul>
                <a
                    href="https://www.w3schools.com/css/css_border.asp"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500"
                >
                    More Style Visit W3Schools
                </a>
                </div>
            </div>

            <div className="py-44"></div>
        </div>
    );
};

export default ColorPickerBG;
